
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.522","height":"16.522","viewBox":"0 0 16.522 16.522"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.87.969a.982.982 0 111.935.253.874.874 0 00.095.685 1.619 1.619 0 002.723 0 .88.88 0 00.095-.685.986.986 0 111.165.692.833.833 0 00-.53.378c-.422.7.133 1.32.64 1.943a6.725 6.725 0 01-5.469 0c.516-.634 1.07-1.241.644-1.948a.821.821 0 00-.528-.378.973.973 0 01-.77-.94zm9.284 9.668h1.643a.714.714 0 100-1.428h-1.654a.839.839 0 01-.844-.724.826.826 0 01.526-.919l1.535-.6a.71.71 0 00.409-.927.728.728 0 00-.941-.4l-1.579.613a.481.481 0 01-.637-.277 7.37 7.37 0 00-.427-.817A7.73 7.73 0 018.261 6.19a7.593 7.593 0 01-3.926-1.029 6.649 6.649 0 00-.414.789.483.483 0 01-.648.3l-1.58-.612a.728.728 0 00-.941.4.711.711 0 00.408.927l1.537.6a.822.822 0 01.531.877.842.842 0 01-.849.765H.725a.714.714 0 100 1.428h1.643a.861.861 0 01.871.727.884.884 0 01-.517 1.007l-1.666.742a.711.711 0 00-.362.945.73.73 0 00.96.356l1.765-.784a.461.461 0 01.62.179 4.636 4.636 0 008.4.071.5.5 0 01.662-.25l1.763.784a.731.731 0 00.961-.357.709.709 0 00-.362-.944l-1.667-.743a.879.879 0 01-.525-.952.864.864 0 01.879-.779z"}})])
          )
        }
      }
    